import React, { useState } from 'react';
import moment from 'moment';
import { string, object, array, bool } from 'prop-types';

import Slider from '../../Slider/Slider';

import { useMedia } from '../../../utils/hooks';
import { getFormattedTime } from '../../../utils/getFormatedTime';

import './CollectionItem.scss';

const CollectionItem = ({
  name,
  title,
  endTime,
  startTime,
  date,
  type,
  description,
  pictures,
  link,
  subDescription,
  staticText,
  isCollapsible,
}) => {
  const [isOpen, setIsOpen] = useState(!isCollapsible);
  const [isOpenSubDescription, setIsOpenSubDescription] = useState(false);

  const isMobileVersion = useMedia(
    ['(min-width: 768px)', '(min-width: 280px)'],
    [false, true],
  );

  const links = link.filter((item) => item.linkHref);

  const renderLinks = (className) =>
    !!links.length && (
      <ul className={className}>
        {links.map((item) => (
          <li key={item.id} className="collection-item__link">
            <a href={item.linkHref}>{item.linkTitle || item.linkHref}</a>
          </li>
        ))}
      </ul>
    );

  const renderDescription = () =>
    description && (
      <h2
        className="collection-item__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    );

  const renderSubDescription = () =>
    subDescription && (
      <div className="collection-item__list">
        <div className="collection-item__btn-container">
          <button
            type="button"
            onClick={() => setIsOpenSubDescription((prevState) => !prevState)}
            style={{
              ...(!isOpenSubDescription && { marginBottom: 0 }),
            }}
          >
            {isOpenSubDescription ? (
              <span className="read-less">{staticText.eventReadLess}</span>
            ) : (
              <span className="read-more">{staticText.eventReadMore}</span>
            )}
          </button>
        </div>
        {isOpenSubDescription && (
          <div className="collection-item__list-container">
            <h3
              className="collection-item__sub-description"
              dangerouslySetInnerHTML={{ __html: subDescription }}
            />
          </div>
        )}
      </div>
    );

  const renderSlider = () => (
    <div className="collection-item__content-container">
      <div className="collection-item__slider-container">
        <Slider pictures={pictures} orientation="horizontal" />
      </div>
    </div>
  );

  return (
    <div
      className={`collection-item${isCollapsible ? '' : ' collection-item--static'}`}
    >
      <div className="collection-item__info">
        <div className="collection-item__title-container">
          {name && (
            <span
              className="collection-item__name"
              dangerouslySetInnerHTML={{ __html: name }}
            />
          )}
          <span
            className="collection-item__title"
            dangerouslySetInnerHTML={{
              __html: title ? `${name ? ', ' : ''}${title}` : '',
            }}
          />
        </div>

        <div className="collection-item__subtitle-container">
          {type && (
            <span
              className="collection-item__subtitle"
              dangerouslySetInnerHTML={{ __html: `(${type})` }}
            />
          )}
          {date && (
            <span className="collection-item__date">
              {`${moment(date, 'YYYY-MM-DD').format('MMM D, YYYY')}.${startTime && endTime ? ` ${getFormattedTime(startTime)} — ${getFormattedTime(endTime)}` : ''}`}
            </span>
          )}
        </div>

        {isCollapsible && (
          <div className="collection-item__btn-container">
            <button
              type="button"
              onClick={() => setIsOpen((prevState) => !prevState)}
              style={{
                position: 'absolute',
                top: '17px',
                left: 0,
                ...(!isOpen && { marginBottom: 0 }),
              }}
            >
              {isOpen ? (
                <span className="read-less" />
              ) : (
                <span className="read-more" />
              )}
            </button>
          </div>
        )}

        {isOpen &&
          (isMobileVersion ? (
            <>
              {renderLinks('collection-item__link-wrapper')}
              {renderSlider()}
            </>
          ) : (
            <>
              {renderLinks()}
              {renderDescription()}
              {renderSubDescription()}
            </>
          ))}
      </div>

      {isOpen && (
        <div className="collection-item__content">
          {isMobileVersion ? (
            <>
              {renderDescription()}
              {renderSubDescription()}
            </>
          ) : (
            renderSlider()
          )}
        </div>
      )}
    </div>
  );
};

CollectionItem.propTypes = {
  name: string,
  title: string,
  type: string,
  date: string,
  endTime: string,
  startTime: string,
  description: string,
  subDescription: string,
  pictures: object,
  link: array,
  staticText: object,
  isCollapsible: bool,
};

CollectionItem.defaultProps = {
  name: '',
  title: '',
  type: '',
  date: '',
  description: '',
  subDescription: '',
  pictures: {},
  endTime: '',
  startTime: '',
  link: [],
  staticText: {},
  isCollapsible: true,
};

export default CollectionItem;
